import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import style from './FMTreeNode.style';
import { FMIcon } from 'atoms';

interface Props {
    children: React.ReactNode;
    level: number;
    classes: any;
    selected: boolean;
    selectNode?: () => void;
}

class FMTreeNode extends React.Component<Props> {

    private nodeRef: any;

    constructor(props: Props) {
        super(props);

        this.nodeRef = React.createRef();
    }

    private selectNode = (event: any) => {
        if (event.target.tagName === 'INPUT') {
            return;
        }

        if (this.props.selectNode) {
            this.props.selectNode();
        }
    }

    public componentDidMount() {
        this.scrollToSelectedNode();
    }

    public componentDidUpdate() {
        this.scrollToSelectedNode();
    }

    private scrollToSelectedNode() {
        if (this.props.selected) {
            this.nodeRef.current.scrollIntoView({ block: 'nearest' });
        }
    }

    public render() {
        let spaces = [];
        for (let i = 0; i < this.props.level; i += 1) {
            spaces.push(<FMIcon type="empty" key={i} />);
        }

        return (
            <div
                className={`${this.props.classes.fmTreeNode} ${this.props.selected ? this.props.classes.selected : ''}`}
                ref={this.nodeRef}
                onClick={this.selectNode}
            >
                {spaces}
                {this.props.children}
            </div>
        );
    }

}

export default withStyles(style)(FMTreeNode);
